import { apiRequest } from "../../utils/apiUtils";

export const friendApi = {
  getFriendRecommend: () =>
    apiRequest<any[]>("get", "/friend-recommend/dailyStats", {
      fullResponse: true,
    })
      .then((response) => {
        if (response && "data" in response) {
          return response.data.map((obj) => ({
            ...obj,
            date: obj.date.slice(0, 10),
          }));
        }
        return null;
      })
      .catch((e) => {
        console.log(e);
      }),
  getFriendRecommendUse: () =>
    apiRequest<any[]>("get", "/friend-recommend-use/allList", {
      fullResponse: true,
    }).then((response) => {
      if (response && "data" in response) {
        return response.data.map((obj) => ({
          ...obj,
          date: obj.createDt.slice(0, 10),
        }));
      }
      return null;
    }),
  registerFriendRecommend: (body: any) =>
    apiRequest<any>("post", "/friend-recommend/adminRegister", {
      data: body,
      fullResponse: true,
    }),
  removeFriendRecommend: (body: any) =>
    apiRequest<any>("post", "/friend-recommend/remove", {
      data: body,
      fullResponse: true,
    }),
  getFriendRecommends: () =>
    apiRequest<any>("get", "/friend-recommend/allList", { fullResponse: true }),
  getFriendRecommendsById: (page: number, limit: number, search: string) =>
    apiRequest<any>(
      "get",
      `/admin/friend-recommend/list?page=${page}&limit=${limit}&search=${search}`,
      {
        fullResponse: true,
      }
    ),
};
